import React from 'react';
import { createRoot } from 'react-dom/client';
import PortalNotifications from './App';

const elementContainer = document.querySelector<HTMLElement>('#portal-notifications-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<PortalNotifications />);
}
